import Markdown from "react-markdown";
import { Link } from "react-router-dom";
import { formatRelative } from "date-fns";
import styles from "./index.module.scss";
import { UserType } from "../../../../types/userType";
import { Text } from "../../../Type";
import { X } from "../../../Icons/general-interface-1";
import ProfileIcon from "../../../UserInterface/ProfileIcon";
import RoleLabel from "../../../UserInterface/RoleLabel";

type PropsType = {
  author: UserType;
  message: string;
  date: string;
  onClose: () => void;
};

const Message = ({ author, message, date, onClose }: PropsType) => {
  const components = {
    p({ children }) {
      return <Text>{children}</Text>;
    },
    a({ children, ...props }) {
      const url = new URL(props.href);
      return <Link to={url.pathname}>{children}</Link>;
    },
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconContents}>
        <ProfileIcon
          name={`${author.first_name} ${author.last_name}`}
          userRole={author.role.name}
          size="medium"
        />
      </div>
      <div className={styles.contents}>
        <div className={styles.title}>
          <Text size="small" weight="bold">
            {`${author.first_name} ${author.last_name}`}{" "}
            <RoleLabel userRole={author.role.name} />
          </Text>
          <Text size="small" className={styles.date}>
            {formatRelative(new Date(date), new Date())}
          </Text>
        </div>
        <Markdown
          components={components}
          className={styles.message}
          allowedElements={["p", "a"]}
        >
          {message}
        </Markdown>
      </div>
      <button type="button" className={styles.close} onClick={onClose}>
        <X width={12} height={12} />
      </button>
    </div>
  );
};

export default Message;
